export const LOCALES: Record<string, string> = {
  sv: 'Swedish',
  en: 'English',
  nb: 'Norwegian',
};
